import { Dialog } from '@material-ui/core';
import React from 'react';

import './LoadingHU.css';
import logoHU from './assets/spinnerLoading.png';

export function LoadingHU({ state }) {
  return (
    <>
      <Dialog
        className="LoadingHU"
        open={state}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="LoadingHU-containter">
          <img className="loadingImage" src={logoHU} alt="logo" />
          <p className="loadingText">  Carregando </p>
        </div>

      </Dialog>
    </>
  );
}
